import { render } from "./IndividualJourneyPlan.vue?vue&type=template&id=40230f7e"
import script from "./IndividualJourneyPlan.vue?vue&type=script&lang=js"
export * from "./IndividualJourneyPlan.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__